import { type ReactNode } from "react";

import "./editorPage.css";

/** Shared detail/form frame: navigation above the sheet, actions beside its title. */
export function EditorPage({ className = "", back, actions, children }: {
  className?: string;
  back: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={`editor-page ${className}`}>
      <header className="app-toolbar editor-page-navigation">
        <div className="app-toolbar-title">{back}</div>
        {actions ? <div className="app-toolbar-actions">{actions}</div> : null}
      </header>
      {children}
    </div>
  );
}

export function EditorHeader({ kicker, title, actions, className = "" }: {
  kicker?: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`editor-header ${className}`}>
      <div className="editor-header-copy">
        {kicker ? <p className="section-kicker">{kicker}</p> : null}
        <h1>{title}</h1>
      </div>
      {actions ? <div className="editor-header-actions">{actions}</div> : null}
    </div>
  );
}

export function EditorPanel({ className = "", label, children }: {
  className?: string;
  label?: string;
  children: ReactNode;
}) {
  return <section className={`panel panel-primary editor-panel ${className}`} aria-label={label}>{children}</section>;
}
